// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ug51","checkboxCol":"Table_checkboxCol__2fzBj","emailCol":"Table_emailCol__3-kxd","actionCol":"Table_actionCol__1mbIx"};